"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionStore = require("@/api/distributionStore");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var cardConfig = function cardConfig() {
  return {
    cardType: 1,
    cardTimes: 1,
    validNum: 30,
    validUnit: 'day',
    validStartType: 1,
    verifyFrequency: 0,
    needRealName: false,
    needReservation: false,
    supportRefund: true,
    autoRefundExpired: false
  };
};
var emptyForm = function emptyForm() {
  return {
    id: null,
    cateId: null,
    name: '',
    image: '',
    sliderImage: '',
    intro: '',
    content: '',
    unitName: '件',
    productType: 0,
    specType: 0,
    verifyEnable: 1,
    expressEnable: 0,
    status: 0,
    sort: 0,
    source: 1,
    brandId: 0,
    brandSource: 0,
    attrList: [],
    skuList: [{
      sku: '',
      image: '',
      price: 0,
      otPrice: 0,
      cost: 0,
      stock: 0
    }],
    cardConfig: cardConfig()
  };
};
var _default = exports.default = {
  name: 'DistributionStoreProduct',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      commissionVisible: false,
      commissionSaving: false,
      rows: [],
      total: 0,
      categories: [],
      brands: [],
      brandKey: '',
      query: {
        page: 1,
        limit: 20,
        keyword: '',
        productType: null,
        status: null
      },
      form: emptyForm(),
      commission: {},
      rewardFields: [{
        label: '直推奖励',
        type: 'directRewardType',
        value: 'directRewardValue'
      }, {
        label: '间推奖励',
        type: 'indirectRewardType',
        value: 'indirectRewardValue'
      }, {
        label: '团队奖励',
        type: 'teamRewardType',
        value: 'teamRewardValue'
      }],
      rules: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请输入商品主图地址',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    libraryProduct: function libraryProduct() {
      return this.form.source === 0;
    },
    verifyEnabled: {
      get: function get() {
        return this.form.verifyEnable === 1;
      },
      set: function set(value) {
        this.form.verifyEnable = value ? 1 : 0;
      }
    },
    expressEnabled: {
      get: function get() {
        return this.form.expressEnable === 1;
      },
      set: function set(value) {
        this.form.expressEnable = value ? 1 : 0;
      }
    }
  },
  created: function created() {
    this.loadOptions();
    this.load();
  },
  methods: {
    loadOptions: function () {
      var _loadOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, categories, brands;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.all([(0, _distributionStore.storeCategoryList)({}), (0, _distributionStore.storeBrandOptions)()]);
            case 1:
              _yield$Promise$all = _context.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              categories = _yield$Promise$all2[0];
              brands = _yield$Promise$all2[1];
              this.categories = categories || [];
              this.brands = brands || [];
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function loadOptions() {
        return _loadOptions.apply(this, arguments);
      }
      return loadOptions;
    }(),
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _distributionStore.storeProductPage)(this.query);
            case 2:
              res = _context2.v;
              this.rows = res.records || [];
              this.total = Number(res.total || 0);
            case 3:
              _context2.p = 3;
              this.loading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    sizeChange: function sizeChange(limit) {
      this.query.limit = limit;
      this.query.page = 1;
      this.load();
    },
    openCreate: function openCreate() {
      this.form = emptyForm();
      this.brandKey = '';
      this.visible = true;
    },
    openEdit: function () {
      var _openEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var detail;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _distributionStore.storeProductDetail)(row.id);
            case 1:
              detail = _context3.v;
              this.form = Object.assign(emptyForm(), detail, {
                cardConfig: Object.assign(cardConfig(), detail.cardConfig || {}),
                skuList: detail.skuList && detail.skuList.length ? detail.skuList : emptyForm().skuList
              });
              this.brandKey = detail.brandId ? "".concat(detail.brandSource || 0, "-").concat(detail.brandId) : '';
              this.visible = true;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function openEdit(_x) {
        return _openEdit.apply(this, arguments);
      }
      return openEdit;
    }(),
    submit: function submit() {
      var _this = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var parts;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (valid) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                if (!(!_this.form.skuList.length || _this.form.skuList.some(function (sku) {
                  return sku.price === null || sku.stock === null;
                }))) {
                  _context4.n = 2;
                  break;
                }
                return _context4.a(2, _this.$message.warning('请完善规格售价和库存'));
              case 2:
                if (!(_this.form.productType !== 8 && !_this.verifyEnabled && !_this.expressEnabled)) {
                  _context4.n = 3;
                  break;
                }
                return _context4.a(2, _this.$message.warning('至少选择一种履约方式'));
              case 3:
                if (_this.brandKey) {
                  parts = _this.brandKey.split('-');
                  _this.form.brandSource = Number(parts[0]);
                  _this.form.brandId = Number(parts[1]);
                } else {
                  _this.form.brandId = 0;
                  _this.form.brandSource = 0;
                }
                if (_this.form.productType === 8) {
                  _this.form.verifyEnable = 1;
                  _this.form.expressEnable = 0;
                } else {
                  _this.form.cardConfig = null;
                }
                _this.form.sliderImage = _this.form.sliderImage || _this.form.image;
                _this.saving = true;
                _context4.p = 4;
                _context4.n = 5;
                return _this.form.id ? (0, _distributionStore.storeProductUpdate)(_this.form) : (0, _distributionStore.storeProductSave)(_this.form);
              case 5:
                _this.$message.success('保存成功');
                _this.visible = false;
                _this.load();
              case 6:
                _context4.p = 6;
                _this.saving = false;
                return _context4.f(6);
              case 7:
                return _context4.a(2);
            }
          }, _callee4, null, [[4,, 6, 7]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    toggle: function () {
      var _toggle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _distributionStore.storeProductToggle)(row.id, row.status);
            case 1:
              this.$message.success(row.status ? '已上架' : '已下架');
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function toggle(_x3) {
        return _toggle.apply(this, arguments);
      }
      return toggle;
    }(),
    openCommission: function () {
      var _openCommission = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _distributionStore.storeProductCommission)(row.id);
            case 1:
              this.commission = _context6.v;
              this.commissionVisible = true;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function openCommission(_x4) {
        return _openCommission.apply(this, arguments);
      }
      return openCommission;
    }(),
    saveCommission: function () {
      var _saveCommission = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              this.commissionSaving = true;
              _context7.p = 1;
              _context7.n = 2;
              return (0, _distributionStore.storeProductCommissionSave)(this.commission);
            case 2:
              this.$message.success('淘客设置已保存');
              this.commissionVisible = false;
            case 3:
              _context7.p = 3;
              this.commissionSaving = false;
              return _context7.f(3);
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this, [[1,, 3, 4]]);
      }));
      function saveCommission() {
        return _saveCommission.apply(this, arguments);
      }
      return saveCommission;
    }(),
    remove: function remove(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u5546\u54C1\u201C".concat(row.name, "\u201D\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return (0, _distributionStore.storeProductDelete)(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.load();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      })));
    }
  }
};